import React, { useRef, useEffect, KeyboardEvent, ChangeEvent } from 'react';
import MaterialInput from '../MaterialInput';
import { TextFieldProps } from '@mui/material';

type AutoGrowingInputProps = {
  value?: string | null;
  onChange?: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  maxHeight?: number;
} & Omit<TextFieldProps, 'onChange'>;

const AutoGrowingInput: React.FC<AutoGrowingInputProps> = ({ value, onChange, maxHeight = 160, error, ...rest }) => {
  const textareaRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';

      let newHeight = textarea.scrollHeight;

      if (maxHeight && newHeight > maxHeight) {
        newHeight = maxHeight;
        textarea.style.overflowY = 'auto';
      } else {
        textarea.style.overflowY = 'hidden';
      }

      textarea.style.height = `${newHeight}px`;
    }
  }, [value, maxHeight, error]);

  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    e.target.value = e.target.value.replace(/\n/g, '');
    onChange?.(e);
  };

  return (
    <MaterialInput
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      ref={textareaRef}
      error={error}
      value={value}
      {...rest}
      multiline
    />
  );
};

export default AutoGrowingInput;
